<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.3987 10.4754L7.4805 3.23936C6.93054 2.90508 6.24337 2.89408 5.6827 3.20934C5.12204 3.5246 4.77515 4.11811 4.77515 4.76165V19.2337C4.77515 19.8772 5.12204 20.4707 5.6827 20.786C6.24337 21.1013 6.93054 21.0902 7.4805 20.756C10.5611 18.8854 16.4089 15.3355 19.3987 13.5199C19.9307 13.1967 20.2554 12.6202 20.2554 11.9977C20.2554 11.3752 19.9307 10.7977 19.3987 10.4754Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Play'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
